import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MockInterceptor } from './interceptors/mock.interceptor';

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: MockInterceptor,
        multi: true
    }]
})
export class MockModule { }
